import { logout, startAuthFlow } from '@src/state/auth/actions'
import { getLoggedIn } from '@src/state/auth/selectors'
import { getSiteConfig } from '@src/state/site/selectors'
import { SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import { DropDownAccountMenu, InlineAccountMenu } from './AccountMenu'
import { AccountUrl } from './AccountMenu/types'

const Right = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

interface DispatchProps {
  signin?: () => void
  signup?: () => void
  logout: () => void
}

interface StateProps extends AccountUrl {
  loggedIn?: boolean
  site: SiteState
}

type Props = DispatchProps & StateProps

export const RightSide = (props: Props) => (
  <Right>
    <InlineAccountMenu site={props.site} loggedIn={props.loggedIn} />
    <DropDownAccountMenu
      site={props.site}
      loggedIn={props.loggedIn}
      logOut={props.logout}
      signIn={props.signin}
      signUp={props.signup}
      accountUrl={props.accountUrl}
    />
  </Right>
)

const mapStateToProps = (state: RootState) => ({
  loggedIn: getLoggedIn(state),
  site: state.site,
  accountUrl: getSiteConfig(state).accountUrl,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  signup: () => dispatch(startAuthFlow({ view: 'signup' })),
  signin: () => dispatch(startAuthFlow({ view: 'signin' })),
  logout: () => dispatch(logout({})),
})

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(RightSide)



// WEBPACK FOOTER //
// ./src/components/Header/RightSide.tsx